import { render, staticRenderFns } from "./InvoiceJl.vue?vue&type=template&id=520ce480&scoped=true&"
import script from "./InvoiceJl.vue?vue&type=script&lang=js&"
export * from "./InvoiceJl.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceJl.vue?vue&type=style&index=0&id=520ce480&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ce480",
  null
  
)

export default component.exports